module.exports = __webpack_public_path__ + "img/oldman_landing_bg.c8d01612.jpg";